import { createContext, Dispatch, SetStateAction, useContext } from "react";

import { DealBase, ICategorizedFile, IEmail, ISuggestion } from "store/types";

import { EmailInboxFilter } from "../EmailInbox";

export interface IPagination {
  page: number;
  per_page: number;
  total: number;
}

export interface onMoveEmailData {
  email: IEmail;
  deal: DealBase;
  categorizedFiles?: ICategorizedFile[];
  extract_with_ai?: boolean;
  is_reassign?: boolean;
}

export interface IHandleOpenPreviewProps {
  email: IEmail;
  isReAssign?: boolean;
}

export interface IEmailsContext {
  emailsData: IEmail[];
  loading: boolean;
  isFullScreen: boolean;
  setIsFullScreen: (isFullScreen: boolean) => void;
  searchValue: string;
  setSearchValue: (searchValue: string) => void;
  filter: EmailInboxFilter;
  setFilter: (filter: EmailInboxFilter) => void;
  pagination: IPagination;
  setPagination: Dispatch<SetStateAction<IPagination>>;
  selectedEmails: IEmail[];
  setSelectedEmails: (emails: IEmail[]) => void;
  selectedDeal: DealBase | null;
  setSelectedDeal: (deal: DealBase | null) => void;
  onMove: (data: onMoveEmailData) => void;
  handleMultipleMove: () => void;
  handleMultipleDelete: () => void;
  handleDelete: (emailId: number) => void;
  onCancelSelectDeal: () => void;
  onSelectEmail: (email: IEmail) => void;
  onFilterChange: (filter: EmailInboxFilter) => void;
  scrollContainerRef: React.RefObject<HTMLDivElement> | null;
  sort: "desc" | "asc";
  onSortChange: (sort: "desc" | "asc") => void;
  handleOpenPreview: (props: IHandleOpenPreviewProps) => void;
  emailPreviewId: number | null;
  setSuggestionDeal: (suggestion: ISuggestion, emailId: number) => void;
  onMoveWithAiExtraction: (email: IEmail, selectedDeal: DealBase) => void;
}

export const EmailsContext = createContext<IEmailsContext>({} as IEmailsContext);

export const useEmailsContext = (): IEmailsContext => useContext(EmailsContext);
